import { Skull, Crosshair, Target, Biohazard } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type GameAccent = 'red' | 'green' | 'zinc'
export type GameStatus = 'live' | 'soon'

export interface Game {
  /** Stable unique id (used as React key). */
  id: string
  /** Display name of the game. */
  name: string
  /** Short subtitle describing the game mode / vibe. */
  tagline: string
  /** Card image (live games). Optional — coming-soon cards use an icon instead. */
  image?: string
  /** Icon shown on compact "coming soon" cards. */
  icon?: LucideIcon
  /** Accent color theme for the card. */
  accent: GameAccent
  /** Whether the server is live or coming soon. */
  status: GameStatus
  /** Featured upcoming games stay in the large card grid instead of the compact horizon row. */
  featured?: boolean
  /** External link to the game's own site (only for live games). */
  href?: string
  /** Optional small badge label shown on the card. */
  badge?: string
  /** Optional secondary badge for a related upcoming mode. */
  secondaryBadge?: string
  /** Call-to-action button label. */
  cta: string
}

/**
 * Data-driven list of Uliunai games.
 * Live and featured upcoming games render as large photo cards; the rest of
 * the upcoming games render as compact icon cards in the "On the horizon" row.
 */
export const games: Game[] = [
  // --- Featured ---
  {
    id: 'kf1',
    name: 'Killing Floor',
    tagline: 'Co-op zed survival',
    image: '/games/kf1.jpg',
    accent: 'red',
    status: 'live',
    href: 'https://kf1.uliunai.com',
    cta: 'Play',
  },
  {
    id: 'minecraft',
    name: 'Minecraft',
    tagline: 'Vanilla live · Modded coming soon',
    image: '/games/uliunai-minecraft-card.png',
    accent: 'green',
    status: 'live',
    featured: true,
    badge: 'Vanilla Live',
    secondaryBadge: 'Modded Soon',
    href: 'https://mc.uliunai.com',
    cta: 'Play Vanilla',
  },

  // --- On the horizon (coming soon) ---
  {
    id: 'kf2',
    name: 'Killing Floor 2',
    tagline: 'Six-player zed-slaying',
    icon: Skull,
    accent: 'zinc',
    status: 'soon',
    cta: 'Coming Soon',
  },
  {
    id: 'cs16',
    name: 'Counter-Strike 1.6',
    tagline: 'Classic tactical FPS',
    icon: Crosshair,
    accent: 'zinc',
    status: 'soon',
    cta: 'Coming Soon',
  },
  {
    id: 'cs2',
    name: 'Counter-Strike 2',
    tagline: 'Modern tactical FPS',
    icon: Target,
    accent: 'zinc',
    status: 'soon',
    cta: 'Coming Soon',
  },
  {
    id: 'l4d2',
    name: 'Left 4 Dead 2',
    tagline: 'Co-op zombie shooter',
    icon: Biohazard,
    accent: 'zinc',
    status: 'soon',
    cta: 'Coming Soon',
  },
]
